import type { Ref } from "vue";
import type { Requests } from "../common/request.common";
import type { WarehouseItemTypeResponseTypes } from "../common/response.common";
import type { SelectHook, SelectParam } from "../common/types.common";
import { asUpdateHook, buildSelectParam, get, post } from "./common";

export const warehouseItemType = {
    record(data: typeof Requests.WarehouseItemType.Record.Input) {
        return post<typeof data, WarehouseItemTypeResponseTypes.Record>(
            `/warehouse-item-type/record`,
            data,
        );
    },
    create(data: typeof Requests.WarehouseItemType.Create.Input) {
        return post<typeof data>("/warehouse-item-type/create", data);
    },
    obtain(id: string) {
        return get<WarehouseItemTypeResponseTypes.Obtain>(`/warehouse-item-type/obtain/${id}`);
    },
    formHooks: {
        select: (async (param?: SelectParam) => {
            const req = get<WarehouseItemTypeResponseTypes.Select>(
                `/warehouse-item-type/select` + buildSelectParam(param),
            );

            return (await req.execute()) ?? [];
        }) satisfies SelectHook,
        selectRich: (async (param?: SelectParam) => {
            const req = get<WarehouseItemTypeResponseTypes.SelectRich>(
                `/warehouse-item-type/select-rich` + buildSelectParam(param),
            );

            return (await req.execute()) ?? [];
        }) satisfies SelectHook,
        update(id: string, isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.WarehouseItemType.Update.Input) => {
                return await asUpdateHook(
                    post<typeof data>(`/warehouse-item-type/update/${id}`, data),
                    isLoading,
                );
            };
        },
    },
};
